import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import parse from 'html-react-parser';

const SectionOurServices = ({section, visualAlignment}) => {
  return (
    <div className="bg-[#F8F9FB] text-center lg:text-left px-8 py-14 md:px-24 xl:px-36 2xl:px-60 lg:py-16 w-full">
      <div className="flex flex-col gap-11 lg:flex-row justify-between items-center max-w-7xl mx-auto">
        {visualAlignment == 'left' && <div className="
              sm:flex-shrink-0 flex flex-col items-center justify-center text-center space-y-2
              bg-white px-6 py-4 rounded-2xl
              ">
                <img
                  src={section.image.url}
                  alt="Service Visual"
                  className="object-contain"
                />
            </div>
        }
        <div className="lg:w-3/5">
          {section.header && 
          <p className={clsx('mb-5', section.headerClasses)}>{parse(section.header)}</p>}
          <div className={section.bodyClasses}>{parse(section.body)}</div>
        </div>
        {visualAlignment == 'right' && <div className="
            sm:flex-shrink-0 flex flex-col items-center justify-center text-center space-y-2
            bg-white px-6 py-4 rounded-2xl
            ">
              <img
                src={section.image.url}
                alt="Service Visual"
                className="object-contain max-w-full max-h-72"
              />
          </div>
        }
      </div>
    </div>
  );
};

SectionOurServices.propTypes  = {
section: PropTypes.shape({
      typeOf: PropTypes.string.isRequired,
      header: PropTypes.string,
      headerClasses: PropTypes.string,
      body: PropTypes.string,
      bodyClasses: PropTypes.string,
      showLogo: PropTypes.bool,
      customClasses: PropTypes.string,
      image: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }),
    }).isRequired,
  visual: PropTypes.string,
  visualAlignment: PropTypes.string
}
export default SectionOurServices;
